/**
 * Platform-aware User Avatar component
 *
 * Uses AuthUserButton which works with any auth provider (Firebase, Native).
 */

import AuthUserButton from "./AuthUserButton";

interface UserAvatarProps {
  afterSignOutUrl?: string;
}

export default function UserAvatar({
  afterSignOutUrl = "/",
}: UserAvatarProps) {
  return <AuthUserButton afterSignOutUrl={afterSignOutUrl} size="lg" />;
}
